<div class="base-container narrow">
  <div bdFxLayoutAlign="space-between center" class="header">
    <div class="left">
      <div (click)="back()" class="back">
        <i class="fa fa-chevron-left"></i>
        Zurück
      </div>
      <div class="title">
        Alle Merklisten
      </div>
    </div>
    <div class="nav">
      <button (click)="bookmarksModal.open()">Merkliste erstellen</button>
    </div>
  </div>
  <bd-hr></bd-hr>
  <div class="bookmarks">
    <div bdFxLayoutAlign="space-between center" *ngFor="let folder of folders" class="row">
      <div bdFxFlex="1 1 auto" bdFxLayoutAlign="space-between center" (click)="showFolderDetails(folder.id)" class="bookmark">
        <div class="name">
          {{folder.name}}
        </div>
        <div class="count">
          {{folder.productCount === 0 ? 'Keine Produkte' : folder.productCount + ' Produkt' + (folder.productCount > 1
          ?
          'e' : '')}}
          <i class="fa fa-chevron-right"></i>
        </div>
      </div>
      <div (click)="openDeleteModal(folder.id)" class="delete">
        <img src="assets/images/btn_delete.png" />
      </div>
      <div (click)="duplicateFolder(folder.id)" class="copy">
        <img src="assets/images/btn_duplicate.png" />
      </div>
    </div>
  </div>
</div>

<bd-modal #bookmarksModal [closable]="true" title="Neue Merkliste" class="bookmarks-modal">
  <div class="name">
    Merklistenname
  </div>
  <div class="input-group">
    <input [(ngModel)]="newFolderName" type="text">
    <button (click)="createFolder()">Erstellen</button>
  </div>
</bd-modal>


<bd-modal #deleteModal [closable]="false" title="Merkliste löschen" class="delete-modal">
  <div class="name">
    Möchten Sie diese Merkliste wirklich löschen?
  </div>
  <bd-hr></bd-hr>
  <div class="input-group">
    <button (click)="deleteModal.close()" class="cancel">Nein, nicht löschen</button>
    <button (click)="deleteFolder(folderIdToDelete)" class="accept">Ja, löschen</button>
  </div>
</bd-modal>
